import { KeyboardArrowRight } from "@mui/icons-material";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, type SxProps, type Theme } from "@mui/material";
import type { PropsWithChildren, MouseEventHandler } from "react";

interface MenuGroupProps extends PropsWithChildren {
    name: string;
    icon?: React.ReactNode;
    open?: boolean;
    onClick?: MouseEventHandler;
    indicator?: boolean;
    sx?: SxProps<Theme>;
}

export const MenuGroup = ({ onClick, name, icon, indicator, open, children, ...rest }: MenuGroupProps): JSX.Element => {
    return (
        <>
            <ListItemButton onClick={onClick} title={name} {...rest}>
                {icon ? <ListItemIcon sx={{ minWidth: 42 }}>{icon}</ListItemIcon> : <></>}
                <ListItemText
                    primary={name}
                    sx={t => ({
                        color: t.palette.text.secondary,
                        "& .MuiListItemText-primary": { overflowX: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" },
                    })}
                />
                {indicator ? <KeyboardArrowRight color="disabled" /> : <></>}
            </ListItemButton>
            <Collapse in={open} timeout="auto">
                <List component="div" disablePadding>
                    {children}
                </List>
            </Collapse>
        </>
    );
};
